import { FunctionComponent, useState } from 'react'
import { Box, } from '@material-ui/core'
import styled from 'styled-components/macro'
import { BackendUser, UserFunction } from 'common/types'
import { CommentCard } from './CommentCard'
import { CommentPost, } from 'common/types/comment.types'
import { Loader } from 'components/core/loader'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useEffect } from 'react';


const StyledBox = styled(Box)`
  && {
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
    max-height: 30em;
    overflow-y: scroll;
  }
`
interface CommentsProps {
  user: BackendUser
  comments: CommentPost[]
  postId: string
  setComments: Function
  createComment: Function
  commentCount: number
  setCommentCount: Function
  deleteComment: Function
  updateComment: Function
  handleScroll?: any
  reportContent: Function
  notify: Function
  post: any
  getPost: Function
  backendUserFunctions?: UserFunction[]
}

export const Comments: FunctionComponent<CommentsProps> = ({
  user,
  comments,
  setComments,
  commentCount,
  setCommentCount,
  deleteComment,
  updateComment,
  handleScroll,
  reportContent,
  notify,
  post,
  getPost,
  backendUserFunctions
}) => {
  let params = new URL(window.location as any).searchParams
  let commentReported = params.get('contentReported')

  const [comment, setComment] = useState<any>()

  const [reportedContentId, setReportedContentId] = useState(commentReported)
  const [page, setPage] = useState(0)
  const fetchMore = () => {
    setPage(page + 1)
  }

  useEffect(() => {
    const commentReported = document.getElementById(reportedContentId)
    commentReported?.scrollIntoView()
    getSingleReportedComment()
  }, [])

  const getSingleReportedComment = async () => {
    const singleComment = await getPost(reportedContentId)
    setComment(singleComment)
  }


  return (
    <Box display="flex" flexDirection="column" alignContent="left">
      <StyledBox justifyContent="center" width="100%" onScroll={handleScroll} maxHeight="80%">
        {!commentReported && comments && (
          <InfiniteScroll
            scrollThreshold="0.4"
            loader={<Loader />}
            hasMore={commentCount > comments?.length}
            next={() => fetchMore()}
            dataLength={comments?.length}
          >
            {comments?.map(p => {
              return (
                <CommentCard
                  reportContent={reportContent}
                  comment={p}
                  key={p?.id}
                  user={user}
                  deleteComment={deleteComment}
                  updateComment={updateComment}
                  setComments={setComments}
                  comments={comments}
                  setCommentCount={setCommentCount}
                  notify={notify}
                  post={post}
                  getPost={getPost}
                  backendUserFunctions={backendUserFunctions}
                />
              )
            })}
          </InfiniteScroll>
        )}
        {commentReported && (
          <CommentCard
            reportContent={reportContent}
            comment={comment}
            key={comment?.id}
            user={user}
            deleteComment={deleteComment}
            updateComment={updateComment}
            setComments={setComments}
            comments={comments}
            setCommentCount={setCommentCount}
            notify={notify}
            post={post}
            getPost={getPost}
            backendUserFunctions={backendUserFunctions}
          />
        )}
      </StyledBox>
    </Box>
  )
}
